module.exports = __webpack_public_path__ + "img/648c024d86063383d4ffbafd6e9e40cb.svg";